import CopyIcon from '@mui/icons-material/ContentCopy'
import { Alert, Box, IconButton, Tooltip } from '@mui/material'
import { useNotify, useTranslate } from 'ra-core'

const SALES_EMAIL = 'sales@mymove.co'

const SalesEmailFallback = () => {
  const translate = useTranslate()
  const notify = useNotify()

  const copySalesEmail = () =>
    navigator.clipboard.writeText(SALES_EMAIL).then(() => notify('mymove.salesRequest.emailCopied', { type: 'info' }))

  return (
    <Alert severity="error" sx={{ mt: 2, alignItems: 'center' }}>
      <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.5}>
        {translate('mymove.salesRequest.sendError')} <strong>{SALES_EMAIL}</strong>
        <Tooltip title={translate('mymove.salesRequest.copyEmail')}>
          <IconButton size="small" onClick={copySalesEmail} aria-label={translate('mymove.salesRequest.copyEmail')}>
            <CopyIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
    </Alert>
  )
}

export default SalesEmailFallback
